<template>
    <div class="content-wrapper hide-layout">
        <mb-erickson-header v-if="!hidePageLayout" :title="title"></mb-erickson-header>

        <div :class="{'hide-layout': hidePageLayout}">
            <transition name="fade">
                <router-view />
            </transition>
        </div>

        <mb-erickson-footer v-if="!hidePageLayout"></mb-erickson-footer>
    </div>
</template>

<script>
import MbPageService from "@/views/subscriptions/MbPageService"
import MbEricksonFooter from "./components/layout/MbEricksonFooter";
import MbEricksonHeader from "./components/layout/MbEricksonHeader";

export default{
    name: "App",
    components: {
        MbEricksonFooter,
        MbEricksonHeader
    },
    data() {
        return {
            hidePageLayout: true,
            title: ''
        }
    },
    beforeCreate() {
        MbPageService.app = this
    },
    metaInfo() {
        return { 
            title: "Edizioni Erickson - iscrizioni",
            meta: [
                { name: 'description', content: 'Sito di gestione iscrizioni per Edizioni Erickson,'},
                { property: 'og:title', content: "Iscrizioni Erickson"},
                { property: 'og:type', content: 'website'},    
                { name: 'robots', content: 'index,follow'} 
            ]
        }
    }
}
</script>

<style>


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

.content-wrapper.hide-layout{
    padding-left: 0px;
}

html, body{
    overflow-x:hidden !important;
}
div#erickson-content-wrapper {
    padding-top: 0 !important;
}
.header_nl, .breadcrumb_nl, .banner_nl{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}
.banner_nl img {
    max-width: 250px;
    transform: rotate(-7deg);
    margin-right: 15px;
}
.h1_nl {
    display: grid;
    align-items: center;
}
.banner_nl h1{
    color: white !important;
}
.banner_nl strong {
    font-family: 'freightsans_probold' !important;
}
.h1_nl::after {
    content: "";
    position: absolute;
    display: block;
    background: #b5161a;
    height: 100px;
    width: 9000px;
    left: -1000px;
    z-index: -1;
}
.grey-container {
    background: white !important;
}
input, .e-select span {
    border-color: #707070 !important;
    border-radius: 5px !important;
}
button#btn-create-account {
    border-radius: 12px !important;
}
@media screen and (max-width:768px) {
    .banner_nl {
        flex-direction: column;
    }
    .h1_nl::after {
        height: 150px;
    }
}
</style>
